import useApi from "./useApi";
import { useContext } from "react";
import { JobContext } from "../contexts/JobContext";

const useJobs = () => {
    const { setJob, job } = useContext(JobContext);
    const { getJson } = useApi();

    /**
     * Fetches a job by its UUID and updates session storage
     * @param query
     */
    const fetchJobWithUuid = async (query) => {
        const _query = query ? `/${query}` : "";
        setJob(null);
        try {
            const res = await getJson(`/online/jobsearch/link${_query}`);
            setJob(res.job[0]);
            return res.job[0];
        } catch (error) {
            console.error("Error fetching job with UUID:", error);
            throw error;
        }
    };
    
    return {
        fetchJobWithUuid,
        job,
        setJob
    }
}

export default useJobs;
